var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-main"},[_c('p',[_c('a',{attrs:{"href":"http://beian.miit.gov.cn","target":"_blank"}},[_vm._v(_vm._s(_vm.data.text1))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.text2))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.text3))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16bac3f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 